import { render, staticRenderFns } from "./CenteredLayout.vue?vue&type=template&id=8e1d15a6"
import script from "./CenteredLayout.vue?vue&type=script&lang=js"
export * from "./CenteredLayout.vue?vue&type=script&lang=js"
import style0 from "./CenteredLayout.vue?vue&type=style&index=0&id=8e1d15a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports